import { __decorate } from "tslib";
import { id_ntQWAC } from "./oids";
import { AsnType, AsnTypeTypes, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
export const id_ValuationRanking = `${id_ntQWAC}.9`;
let ValuationRanking = class ValuationRanking {
    constructor(params = {}) {
        this.stars5 = 0;
        this.stars4 = 0;
        this.stars3 = 0;
        this.stars2 = 0;
        this.stars1 = 0;
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], ValuationRanking.prototype, "stars5", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], ValuationRanking.prototype, "stars4", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], ValuationRanking.prototype, "stars3", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], ValuationRanking.prototype, "stars2", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], ValuationRanking.prototype, "stars1", void 0);
ValuationRanking = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], ValuationRanking);
export { ValuationRanking };
